// The Census geocoder (used by auto-categorize-document's real-estate
// cross-reference) returns everything SHOUTING — "114 WALNUT ST, HARTFORD,
// KY". This normalizes those values for display/export without touching
// anything that's already properly cased (AI web search, manual entry).

const STATE_CODES = new Set([
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA',
  'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT',
  'VA', 'WA', 'WV', 'WI', 'WY', 'DC',
]);

// Only touches strings with no lowercase letters at all, so an
// already-proper-case value passes through untouched.
export function titleCaseIfShouting(value) {
  if (!value) return value;
  if (/[a-z]/.test(value)) return value;
  return value.replace(/[0-9A-Za-z']+/g, (word) => {
    const ordinal = word.match(/^(\d+)(ST|ND|RD|TH)$/i);
    if (ordinal) return ordinal[1] + ordinal[2].toLowerCase();
    if (STATE_CODES.has(word.toUpperCase())) return word.toUpperCase();
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
}

export function titleCaseLocation(loc) {
  if (!loc) return loc;
  return {
    ...loc,
    name: titleCaseIfShouting(loc.name),
    address: titleCaseIfShouting(loc.address),
    city: titleCaseIfShouting(loc.city),
  };
}
